import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { AppPageComponent } from '../../shared/ui';
import { TopLevelComponent, HeaderAction} from '../../shared/models';
import { StoreHelper, Store, UserService } from '../../shared/services';
import {  Product } from '../shared/models';

@Component({
    selector: 'product-transfer',
    styles: [ require('./product-transfer.component.scss') ],
    template: require('./product-transfer.component.pug')
})
export class ProductTransferComponent extends TopLevelComponent implements OnInit {
  @ViewChild(AppPageComponent) appPage;

  product: Product = <Product>{};
  productsToTransfer: Array<Product> = [];
  showTransferOverview: boolean = false;
  initializeFromServer: boolean = false;
  locationDestinationId: number;
  locationOriginId: number;
  fg = new FormGroup({});

  private _searchAction = { id: 'search', icon: '' };

  constructor(
                public _location: Location,
                private _route: ActivatedRoute,
                public _store: Store,
                _storeHelper: StoreHelper,
                _userSvc: UserService
               ) {
          super(_store, _storeHelper, _userSvc);
          this.headerTitle = 'Qty to Transfer';
          this.headerActions = [ this._searchAction ];
          this.subscribeToHeaderActions(this._reactToHeaderAction);
   }

   ngOnInit() {
        let that = this;
        this._route.params.forEach((params: Params) => {
            that.locationDestinationId = +params['locationTo'];
            that.locationOriginId = +params['locationFrom'];
            let productId = +params['productId'];

            let storeState = this.store.getState();

            if (storeState.products) {
                this.product = storeState.products.find(p => p.id === productId );
            }

            this.appPage.deactivatePreloader();
        });
   }

   coverClosed() {
        this.showTransferOverview = false;
        this.headerTitle = 'Qty to Transfer';
    }

    showTransferCover(e: MouseEvent) {
        e.preventDefault();

        let qty = this.fg.controls[this.product.id].value;
        this.productsToTransfer = [];
        this.product.errorInTransfer = false;

        if (qty > 0) {

            this.product.quantity = qty;
            this.productsToTransfer.push(this.product);
            this.showTransferOverview = true;
        }else {
            this.product.errorInTransfer = true;
        }
    }

    goBack() {
        this._location.back();
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id) {
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/product-transfer/product-transfer.component.ts